import { render, staticRenderFns } from "./2-3.QueryDetail.vue?vue&type=template&id=88cecf0e"
import script from "./2-3.QueryDetail.vue?vue&type=script&lang=js"
export * from "./2-3.QueryDetail.vue?vue&type=script&lang=js"
import style0 from "./2-3.QueryDetail.vue?vue&type=style&index=0&id=88cecf0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports